import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Authentication = {
  Forms: {
    Login: lazyNamed(() => import('./forms/Login/index.tsx'), 'Login'),
    Registration: lazyNamed(() => import('./forms/Registration/index.tsx'), 'Registration'),
    Verification: lazyNamed(() => import('./forms/Verification/index.tsx'), 'Verification'),
    RestorePassword: lazyNamed(() => import('./forms/RestorePassword/index.tsx'), 'RestorePassword'),
    ChangePassword: lazyNamed(() => import('./forms/ChangePassword/index.tsx'), 'ChangePassword'),
    ActivateUser: lazyNamed(() => import('./forms/ActivateUser/index.tsx'), 'ActivateUser'),
  },
  Components: {
    Layout: lazyNamed(() => import('./components/Layout/index.tsx'), 'Layout'),
    Redirector: lazyNamed(() => import('./components/Redirector.tsx'), 'Redirector'),
    SSO: lazyNamed(() => import('./components/SSO.tsx'), 'SSO'),
    Autologin: lazyNamed(() => import('./components/Autologin.tsx'), 'Autologin'),
  },
};

export default Authentication;
